global.token = "";
global.fecha_token = "";
global.key = "colorbabySalesforce";
global.accesToken = "";
global.ruta = "https://api.intexserviceiberia.com";
//global.ruta = "http://10.0.0.209:4500";
